import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { BaseStore } from '../base/base.store';
import { AppToken } from "../../../models/app-token";

@Injectable({
    providedIn: 'root'
})
@StoreConfig({
  name: AppToken.PAGE_TYPE_SCHEMA_NAME,
    cache: {
        ttl: 15000
    }
})
export class PageTypeStore extends BaseStore {
    constructor() {
        super();
    }
}
